import { Component, ElementRef, ViewChild, inject } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import {SettingsService} from 'src/app/services/settings.service'
import { Router ,ActivatedRoute} from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { Observable, Subscription, map, startWith } from 'rxjs';
import {AirManagementService}  from 'src/app/services/air-management.service'
import {PaymentConfigService}  from 'src/app/services/payment-config.service'
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import { MatChipInputEvent } from '@angular/material/chips';
import {StaticdataService}  from 'src/app/services/staticdata.service'
import { UserPrivilegeService } from 'src/app/services/user-privilege.service';
import { ColorsService } from 'src/app/services/colors.service';

@Component({
  selector: 'app-air-management',
  templateUrl: './air-management.component.html',
  styleUrls: ['./air-management.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class AirManagementComponent {
  separatorKeysCodes: number[] = [ENTER, COMMA];
  messageTypeCtrl = new FormControl('');
  filteredMessageTypes: Observable<string[]>;
  selectedStateTypes: string[] = [];
  allStateTypes: string[] = [];
  @ViewChild('messageTypeInput') messageTypeInput!: ElementRef<HTMLInputElement>;
  announcer = inject(LiveAnnouncer);

  passThrough:any
  search:any={searchText:""}
  pagestr:any={
    number:'0',
    size:'10'
  }
  supplierSearch:any={searchText:""}
  sourceSearch:any={searchText:""}
  pageStrSupplier:any={
    number:'0',
    size:'10'
  }
  pageStrSource:any={
    number:'0',
    size:'10'
  }
  pageStrCarrier:any={
    number:'0',
    size:'10'
  }
  action:any
  SupplierRegFg!:FormGroup
  groupList:any
  settingJson:any
  totalElements:any=0
  menu:any="20px";
  showCarrier:boolean=false;
  showGroup:boolean=false;
  showSupplier:boolean=false;
  showSource:boolean=false;
  showGroupPopup:boolean=false
  showSupplierPopup:boolean=false
  showSourcePopup:boolean=false
  showCarrierPopup:boolean=false
  showCommission:boolean=false
  showAirport:boolean=false
  showMeals:boolean=false
  showMiles:boolean=false
  columnsGroupDisplay: string[] = ['name','status','creationDate',];
  columnsCarrierDisplay: string[] = ['name','status','creationDate','helpline','blank'];
  columnsSupplierDisplay: string[] = ['name','status','creationDate',];
  columnsSourceDisplay: string[] = ['name','type','supplierCode','status','creationDate',];
  GroupRegFg! : FormGroup
  SourceRegFg!:FormGroup
  CarrierRegFg!:FormGroup
  dataSource:any = [];
  groupData:any = [];
  carrierData:any
  supplierData:any = [];
  sourceData:any = [];
  supplierList:any
  expandedElement!: any | null;
  CreditData:any
  color:any
constructor(private StaticdataService:StaticdataService,private PaymentConfigService:PaymentConfigService,private SettingsService:SettingsService,private router:Router,private location:Location,private fb : FormBuilder,    private toastMsgService : ToastmsgService,
  private AirManagementService:AirManagementService,private userPrivileges: UserPrivilegeService,private ColorsService:ColorsService,
  ){




    this.userPrivileges.userPrivilegesByModule('Air').then((privileges:any) => {
      this.privilegesValue(privileges)
    })
    .catch((error:any) => {
    console.error(error); // Handle errors, if any
    });

    this.ColorsService.colors("","").then((color:any) => {
      this.color=color
     })
     .catch((error:any) => {
     });

    this.creditList()
    this.stateList()
    this.filteredMessageTypes = this.messageTypeCtrl.valueChanges.pipe(
      startWith(null),
      map((type: string | null) => (type ? this._filter(type) : this.allStateTypes.slice())),
      );
  this.SettingsService.airManageJson().then((data:any) => {
    this.settingJson=data["menu"]
    this.showGroup=true
   })
   .catch((error:any) => {
   });

   this.dataFields();
   this.getGrouplist({page: this.pagestr.number, size: this.pagestr.size,})
   this.getSupplierlist({page: this.pageStrSupplier.number, size: this.pageStrSupplier.size,})
   this.getSourcelist({page: this.pageStrSource.number, size: this.pageStrSource.size,})
   this.getCarrierlist({page: this.pageStrSource.number, size: this.pageStrSource.size,})

}
privilegesView:any
  privilegesValue(privs:any){
   
    let privileges="";
  
  if(privs.includes('view')){
    this.privilegesView="VAMD"
  }else{
    this.privilegesView="AccessDenied"
  }
  
  }

dataFields(){
  this.GroupRegFg=this.fb.group({
    "code" :  ['',[Validators.required]],
    "name" : ['',[Validators.required]],
    "status":['A',[Validators.required]],
  });
  
  this.SupplierRegFg=this.fb.group({
    "code" :  ['',[Validators.required]],
    "name" : ['',[Validators.required]],
    "status":['A',[Validators.required]],
    "groupCode":['',[Validators.required]],
    "accountsCode":['',[Validators.required]]
  });

  this.SourceRegFg=this.fb.group({
    "code" :  ['',[Validators.required]],
    "name" : ['',[Validators.required]],
    "status":['A',[Validators.required]],
    "groupCode":['',[Validators.required]],
    "supplierCode":['',[Validators.required]],
    "type":['',[Validators.required]]
  })
  this.CarrierRegFg=this.fb.group({
    "airlineAccountingCode" :  ['',[Validators.required]],
    "airlineDesignatorCode" : ['',[Validators.required]],
    "carrierName" : ['',[Validators.required]],
    "status":['A',[Validators.required]],
    "helplineNo":['']
  });
  
}

OnClickLink(subMenu:any){
  if(subMenu==="Amadeus"){
  this.router.navigate(["/app/Air-Management/Amadeus"]);}
  else if(subMenu==="User"){
    this.router.navigate(["/app/Air-Management/User-config"]);

  }

}


  backClick(){
window.location.href="/app/settings"
  }


  onClickAirports(){
    this.showGroup=false;
    this.showSupplier=false;
    this. showSource=false;
    this.showCarrier=false
    this.showMeals=false
    this.showMiles=false
    this.showCommission=false
    this.showBranchId=false

    this.showAirport=true

  }
  onClickCommission(){
    this.showGroup=false;
    this.showSupplier=false;
    this. showSource=false;
    this.showCarrier=false
    this.showMeals=false
    this.showMiles=false
    this.showAirport=false
    this.showBranchId=false

    this.showCommission=true

  }
  onClickCarrier(){
    this.showCommission=false

    this.showGroup=false;
    this.showSupplier=false;
    this. showSource=false;
    this.showMeals=false
    this.showMiles=false
    this.showAirport=false
    this.showBranchId=false

    this.showCarrier=true
  }
  onClickGroup(){
    this.showCommission=false
    this.showMeals=false
    this.showMiles=false
    this.showAirport=false
    this.showBranchId=false

    this.showGroup=true;
    this.showSupplier=false;
    this. showSource=false;
    this.showCarrier=false


  }
  onClickSupplier(){
    this.showCommission=false

    this.showCarrier=false
    this.showGroup=false;
    this.showMeals=false   
     this.showMiles=false
     this.showBranchId=false

     this.showAirport=false

    this.showSupplier=true;
    this. showSource=false;
    this.Grouplist();
  }
  onClickSource(){
    this.showCommission=false
    this.showAirport=false

    this.showCarrier=false
    this.showGroup=false;
    this.showSupplier=false;
    this.showMeals=false
    this.showMiles=false
    this.showBranchId=false

    this.showSource=true;
    this.Grouplist();
    this.Supplierlist();
    this.sourceCodelist()

  }
  onClickMeals(){
    this.showGroup=false;
    this.showSupplier=false;
    this. showSource=false;
    this.showCarrier=false
    this.showCommission=false
    this.showMiles=false
    this.showAirport=false
    this.showBranchId=false

    this.showMeals=true
    
  }
  onClickMiles(){
    this.showGroup=false;
    this.showSupplier=false;
    this. showSource=false;
    this.showCarrier=false
    this.showCommission=false
    this.showMeals=false
    this.showAirport=false
    this.showBranchId=false

    this.showMiles=true

  }
  showBranchId:boolean=false
  onClickBranch(){
    this.showGroup=false;
    this.showSupplier=false;
    this. showSource=false;
    this.showCarrier=false
    this.showCommission=false
    this.showMeals=false
    this.showAirport=false
    this.showMiles=false
    this.showBranchId=true
  }

  onAddGroup(){
    this.action='newGrp'
    this.showCarrierPopup=false
    this.showGroupPopup=true
    this.showSupplierPopup=false
    this.showSourcePopup=false

  }
  onAddSupplier(){
    this.action='newSupplier'
    this.showCarrierPopup=false
    this.showGroupPopup=false
    this.showSupplierPopup=true
    this.showSourcePopup=false

  }
  
  onAddSource(){
    this.action='newSource'
    this.showCarrierPopup=false
    this.showGroupPopup=false
    this.showSupplierPopup=false
    this.showSourcePopup=true

  }
  onAddCarrier(){
    this.action='newCarrier'
    this.showGroupPopup=false
    this.showSupplierPopup=false
    this.showSourcePopup=false
    this.showCarrierPopup=true
  }
  closePopup() {
    this.fileSelected=false

    this.selectedFile=null
    this.showGstPopup=false

    this.showCarrierPopup=false
    this.showGroupPopup=false
    this.showSupplierPopup=false
    this.showSourcePopup=false
    this.dataFields()
  }
 

  AddGroup() {
    this.AirManagementService.saveGroup(this.GroupRegFg.value)
      .subscribe({
        next : (res) => {
          if(res.status==200 || res.status==201) {
            this.toastMsgService.setMsg({msg : "Group Added Successfully!",msgTitle : "Success", msgType : "I"});
           // this.router.navigate(["/sign-in"]);
           this.dataFields();
           this.showGroupPopup=false
           this.getGrouplist({page: this.pagestr.number, size: this.pagestr.size,})

          } else {
            const body : any = res.body;
            this.registerGroupErrorMsg(res.status,body?.result);
          } 

        },error : (err) => {

          this.registerGroupErrorMsg(err.status,err.error);
        }
      }
    )
  }

  registerGroupErrorMsg(status : number,msg : string) {
    if(status >=500) {
      this.toastMsgService.setMsg({msg : "Failed to save Group",msgTitle : "Warning", msgType : "W"});
    } else {

      this.toastMsgService.setMsg({msg : "Failed to save Group",msgTitle:  "Warning", msgType : "W"});
    } 
  }

  searchUser(){
  
    this.getGrouplist({page: this.pagestr.number, size: this.pagestr.size,})
  }

  nextPage(event:PageEvent) {
    
    let page:any = {};
    page['page'] = event.pageIndex.toString();
    page['size'] = event.pageSize.toString();
    this.getGrouplist(page)
    //this.getAllUser(page)
  
  }
  getGrouplist(page:any){

    this.AirManagementService
    .getGroupList(page,this.search)
    .subscribe({
      next : (res:any) => {
        if(res) {
          const data = res
          if(data.result.content.length>0){
            this.pagestr.number=data.result['number']
            this.pagestr.size=data.result['size']
          }

         // this.Userlist=data.result.content;
         console.log(res)
          this.groupData=data.result.content;
          this.totalElements = data.result['totalElements'];
         if(this.groupData.length>0){
         }else{
          

         }
        } else {
        
        } 
      },error : (err) => {

      }
    }
  )
  }

  Grouplist(){

    this.AirManagementService
    .grouplist()
    .subscribe({
      next : (res:any) => {
        if(res) {
          let data=res
       this.groupList=data
       
        } else {
        
        } 
      },error : (err) => {

      }
    }
  )
  }

  formatDate(val: Date) {
    let convertedValue:any = ""
    if(val){
    let datepipe = new DatePipe("en");
    //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
    convertedValue =  datepipe.transform(val, "dd-MM-yyyy hh:mm:ssa");
    }
    return convertedValue;
  }

  AddCarrier(){

    this.AirManagementService.saveCarrier(this.CarrierRegFg.value)
    .subscribe({
      next : (res) => {
        if(res.status==200 || res.status==201) {
          this.toastMsgService.setMsg({msg : "Carrier Added Successfully!",msgTitle : "Success", msgType : "I"});
         // this.router.navigate(["/sign-in"]);
         this.dataFields();
         this.showCarrierPopup=false
         this.getCarrierlist({page: this.pageStrSource.number, size: this.pageStrSource.size,})

        } else {
          const body : any = res.body;
          this.registerCarruerErrorMsg(res.status,body?.result);
        } 

      },error : (err) => {

        this.registerCarruerErrorMsg(err.status,err.error);
      }
    }
  )
}

UpdateCarrier(){

  this.AirManagementService.UpdateCarrier(this.CarrierRegFg.value)
  .subscribe({
    next : (res) => {
      if(res.status==200 || res.status==201) {
        this.toastMsgService.setMsg({msg : "Carrier Updated Successfully!",msgTitle : "Success", msgType : "I"});
       // this.router.navigate(["/sign-in"]);
       this.dataFields();
       this.showCarrierPopup=false
       this.getCarrierlist({page: this.pageStrSource.number, size: this.pageStrSource.size,})

      } else {
        const body : any = res.body;
        this.toastMsgService.setMsg({msg : "Failed to Update Carrier",msgTitle : "Warning", msgType : "W"});
      } 

    },error : (err) => {

      this.toastMsgService.setMsg({msg : "Failed to Update Carrier",msgTitle : "Warning", msgType : "W"});
    }
  }
)
}

registerCarruerErrorMsg(status : number,msg : string) {
  if(status >=500) {
    this.toastMsgService.setMsg({msg : "Failed to save Carrier",msgTitle : "Warning", msgType : "W"});
  } else {

    this.toastMsgService.setMsg({msg : "Failed to save Carrier",msgTitle:  "Warning", msgType : "W"});
  } 
}

  AddSupplier() {
    this.AirManagementService.saveSupplier(this.SupplierRegFg.value)
      .subscribe({
        next : (res) => {
          if(res.status==200 || res.status==201) {
            this.toastMsgService.setMsg({msg : "Supplier Added Successfully!",msgTitle : "Success", msgType : "I"});
           // this.router.navigate(["/sign-in"]);
           this.dataFields();
           this.showSupplierPopup=false
           this.getSupplierlist({page: this.pageStrSupplier.number, size: this.pageStrSupplier.size,})

          } else {
            const body : any = res.body;
            this.registerSupplierErrorMsg(res.status,body?.result);
          } 

        },error : (err) => {

          this.registerSupplierErrorMsg(err.status,err.error);
        }
      }
    )
  }

  registerSupplierErrorMsg(status : number,msg : string) {
    if(status >=500) {
      this.toastMsgService.setMsg({msg : "Failed to save Supplier",msgTitle : "Warning", msgType : "W"});
    } else {

      this.toastMsgService.setMsg({msg : "Failed to save Supplier",msgTitle:  "Warning", msgType : "W"});
    } 
  }

  searchSupplier(){
  
    this.getSupplierlist({page: this.pageStrSupplier.number, size: this.pageStrSupplier.size,})
  }

  nextSupplierPage(event:PageEvent) {
    
    let page:any = {};
    page['page'] = event.pageIndex.toString();
    page['size'] = event.pageSize.toString();
    this.getSupplierlist(page)
    //this.getAllUser(page)
  
  }
  getSupplierlist(page:any){

    this.AirManagementService
    .getSupplierList(page,this.supplierSearch)
    .subscribe({
      next : (res:any) => {
        if(res) {
          const data = res
          if(data.result.content.length>0){
            this.pagestr.number=data.result['number']
            this.pagestr.size=data.result['size']
          }

         // this.Userlist=data.result.content;
         console.log(res)
          this.supplierData=data.result.content;
          this.totalElements = data.result['totalElements'];
         if(this.supplierData.length>0){
         }else{
          

         }
        } else {
        
        } 
      },error : (err) => {

      }
    }
  )
  }
  fileSelected:boolean=false
  selectedFile:any=null
  onFileSelected(event: any): void {
    
      this.fileSelected=true;

   
    this.selectedFile = event.target.files[0] ?? null;
   
  }

  uploadFile(){
    this.fileSelected=true;

    this.AirManagementService
    .UploadGstbycarrierDesignatorCode(this.airlineDesignatorCode,this.selectedFile)
    .subscribe({
      next : (res:any) => {
        if(res) {

        this.fileSelected=false
        this.selectedFile=null
        this.showGstPopup=false

          this.toastMsgService.setMsg({msg : "Upload File Successfully!",msgTitle : "Success", msgType : "I"});

        } else {
        
        } 
      },error : (err) => {
        this.toastMsgService.setMsg({msg : "Failed to Upload File",msgTitle : "Warning", msgType : "W"});


      }
    }
  )
  }




  Supplierlist(){

    this.AirManagementService
    .supplierlist()
    .subscribe({
      next : (res:any) => {
        if(res) {
       let data=res
       this.supplierList=data
       
        } else {
        
        } 
      },error : (err) => {

      }
    }
  )
  }



  AddSource() {
    this.AirManagementService.saveSource(this.SourceRegFg.value)
      .subscribe({
        next : (res) => {
          if(res.status==200 || res.status==201) {
            this.toastMsgService.setMsg({msg : "Source Added Successfully!",msgTitle : "Success", msgType : "I"});
           // this.router.navigate(["/sign-in"]);
           this.dataFields();
           this.showSourcePopup=false
           this.getSourcelist({page: this.pageStrSource.number, size: this.pageStrSource.size,})

          } else {
            const body : any = res.body;
            this.registerSourceErrorMsg(res.status,body?.result);
          } 

        },error : (err) => {
if(err.status==400){
  this.toastMsgService.setMsg({msg : "already added this Source & Supplier combination",msgTitle : "Warning", msgType : "W"});

}else{
          this.registerSourceErrorMsg(err.status,err.error);}
        }
      }
    )
  }

  registerSourceErrorMsg(status : number,msg : string) {
    if(status >=500) {
      this.toastMsgService.setMsg({msg : "Failed to save Source",msgTitle : "Warning", msgType : "W"});
    } else {

      this.toastMsgService.setMsg({msg : "Failed to save Source",msgTitle:  "Warning", msgType : "W"});
    } 
  }

  searchSource(){
  
    this.getSourcelist({page: this.pageStrSource.number, size: this.pageStrSource.size,})
  }


  nextSourcePage(event:PageEvent) {
    
    let page:any = {};
    page['page'] = event.pageIndex.toString();
    page['size'] = event.pageSize.toString();
    this.getSourcelist(page)
    //this.getAllUser(page)
  
  }
  getSourcelist(page:any){

    this.AirManagementService
    .getSourceList(page,this.sourceSearch)
    .subscribe({
      next : (res:any) => {
        if(res) {
          const data = res
          if(data.result.content.length>0){
            this.pagestr.number=data.result['number']
            this.pagestr.size=data.result['size']
          }

         // this.Userlist=data.result.content;
         console.log(res)
          this.sourceData=data.result.content;
          this.totalElements = data.result['totalElements'];
         if(this.supplierData.length>0){
         }else{
          

         }
        } else {
        
        } 
      },error : (err) => {

      }
    }
  )
  }
 searchCarrier(){
  
    this.getCarrierlist({page: this.pageStrCarrier.number, size: this.pageStrCarrier.size,})
  }
  

  nextCarrierPage(event:PageEvent) {
    
    let page:any = {};
    page['page'] = event.pageIndex.toString();
    page['size'] = event.pageSize.toString();
    this.getCarrierlist(page)
    //this.getAllUser(page)
  
  }
  getCarrierlist(page:any){

    this.AirManagementService
    .getCarrierList(page,this.search)
    .subscribe({
      next : (res:any) => {
        if(res) {
          const data = res
          if(data.result.content.length>0){
            this.pageStrCarrier.number=data.result['number']
            this.pageStrCarrier.size=data.result['size']
          }

         // this.Userlist=data.result.content;
         console.log(res)
          this.carrierData=data.result.content;
          this.totalElements = data.result['totalElements'];
         if(this.groupData.length>0){
         }else{
          

         }
        } else {
        
        } 
      },error : (err) => {

      }
    }
  )
  }

  rowGroupClick(item:any){
    this.action='updateGrp'

    this.showGroupPopup=true;

    this.GroupRegFg=this.fb.group({
      "code" :  [item.code,[Validators.required]],
      "name" : [item.name,[Validators.required]],
      "status":[item.status,[Validators.required]],
    });
  }
  rowSupplierClick(element:any){
    this.action='UpdateSupplier'
    this.showSupplierPopup=true
    this.SupplierRegFg=this.fb.group({
      "code" :  [element.code,[Validators.required]],
      "name" : [element.name,[Validators.required]],
      "status":[element.status,[Validators.required]],
      "groupCode":[element.groupCode,[Validators.required]],
      "accountsCode":[element.accountsCode,[Validators.required]]
    });
  }

rowSourceClick(element:any){
  this.action='updateSource'
  this.showSourcePopup=true
  this.SourceRegFg=this.fb.group({
    "code" :  [element.code,[Validators.required]],
    "name" : [element.name,[Validators.required]],
    "status":[element.status,[Validators.required]],
    "groupCode":[element.groupCode,[Validators.required]],
    "supplierCode":[element.supplierCode,[Validators.required]],
    "type":[element.type,[Validators.required]]
  })
}
rowCarrierClick(element:any){
  this.action='updateCarrier'
  this.showCarrierPopup=true
  this.CarrierRegFg=this.fb.group({
    "airlineAccountingCode" :  [element?.airlineAccountingCode,[Validators.required]],
    "airlineDesignatorCode" : [element?.airlineDesignatorCode,[Validators.required]],
    "carrierName" : [element?.carrierName,[Validators.required]],
    "status":[element?.status,[Validators.required]],
    "helplineNo":[element?.helplineNo]

  });
}
sourceCodeList:any=[]
sourceCodelist(){

  this.AirManagementService
  .sourceCodelist()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.sourceCodeList=data
     
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}

onSourceSelect(event:any){
let sourceName:any
sourceName= this.sourceCodeList.filter((item:any)=>item.code===event.value)

console.log(sourceName[0].title)
this.SourceRegFg.value.name=sourceName[0].title
 this.SourceRegFg=this.fb.group({
    "code" :  [this.SourceRegFg.value.code,[Validators.required]],
    "name" : [this.SourceRegFg.value.name,[Validators.required]],
    "status":[this.SourceRegFg.value.status,[Validators.required]],
    "groupCode":[this.SourceRegFg.value.groupCode,[Validators.required]],
    "supplierCode":[this.SourceRegFg.value.supplierCode,[Validators.required]],
    "type":[this.SourceRegFg.value.type,[Validators.required]]
  })
console.log(this.SourceRegFg.value.name)
}
showCard:boolean=false
onClickPassThrough(){
 if(this.passThrough.length===0){
this.showCard=false
 }else{
  this.showCard=true
 }
}
creditList(){
  this.PaymentConfigService
  .creditCardList()
  .subscribe({
    next : (res:any) => {
      if(res) {

         let data=res
         console.log(data)

     this.CreditData=data
     
      } else {
      
      } 
    },error : (err) => {

    


    }
  }
)
}
showGstPopup:boolean=false
airlineDesignatorCode:any
carrierAction:any
onClickGST(item:any,tab:any){
  this.carrierAction=tab
  this.showGstPopup=true
  this.airlineDesignatorCode=item
  this.getGST()
}
onClickMapping(item:any,tab:any){
  this.carrierAction=tab
  this.showGstPopup=true
  this.airlineDesignatorCode=item
  this.getfarelist()
  this.getForeignlist()

}


GstData:any=[]
add(event: MatChipInputEvent): void {
  const value = (event.value || '').trim();
  console.log( this.selectedStateTypes)

  // Add our fruit
  if (value) {
    this.selectedStateTypes.push(value);

   
  }

  // Clear the input value
  event.chipInput!.clear();

  this.messageTypeCtrl.setValue(null);
}

remove(type: string): void {
  const index = this.selectedStateTypes.indexOf(type);
  this.allStateTypes.push(type);
  if (index >= 0) {
    this.selectedStateTypes.splice(index, 1);

    this.announcer.announce(`Removed ${type}`);
  }

 this.GstData=this.GstData.filter((item:any)=>item.state!==type)
 
  
}

selected(event: MatAutocompleteSelectedEvent): void {
  this.GstData= this.GstData
  this.selectedStateTypes.push(event.option.viewValue);
  let item:any={}

  for(let i=0;i<this.selectedStateTypes.length;i++){

     item={
      state:this.selectedStateTypes[i],
      gstNumber:'',
      isValid:true
    }

  }
   this.GstData.push(item)
 
//  this.GstData = [...this.GstData, item];

console.log(this.GstData)

  this.allStateTypes = this.allStateTypes.filter((itm)=> itm!= event.option.viewValue);
  

  this.messageTypeInput.nativeElement.value = '';
  this.messageTypeCtrl.setValue(null);
 
  
  
}



private _filter(value: string): string[] {
  const filterValue = value.toLowerCase();

  return this.allStateTypes.filter(type => type.toLowerCase().includes(filterValue));
}
stateList(){
  this.StaticdataService
  .getStates()
  .subscribe({
    next : (res:any) => {
      if(res) {

         let data=res
for(let item of data){
this.allStateTypes.push(item?.stateName)
}
      } else {
      
      } 
    },error : (err) => {

    


    }
  }
)
}
isGSTInvalid: boolean = false;






AddGST(){

let gstData:any=[]
gstData=JSON.parse(JSON.stringify(this.GstData))

gstData.forEach((item:any)=>{
  delete item.isValid
 })
let request:any={
  "airlineDesignatorCode":  this.airlineDesignatorCode,
    "carrierGSTList": gstData,
    
}

  this.AirManagementService.saveGstbyCarrier(request)
  .subscribe({
    next : (res) => {
      if(res.status==200 || res.status==201) {
        this.toastMsgService.setMsg({msg : "GST Added Successfully!",msgTitle : "Success", msgType : "I"});
       // this.router.navigate(["/sign-in"]);
this.getGST()
      } else {
        this.getGST()
        const body : any = res.body;
        this.registerGstErrorMsg(res.status,body?.result);
      } 

    },error : (err) => {
      this.getGST()
      this.registerGstErrorMsg(err.status,err.error);
    }
  }
)
}

registerGstErrorMsg(status : number,msg : string) {
if(status >=500) {
  this.toastMsgService.setMsg({msg : "Failed to save GST ",msgTitle : "Warning", msgType : "W"});
} else {

  this.toastMsgService.setMsg({msg : "Failed to save Gst ",msgTitle:  "Warning", msgType : "W"});
} 
}


getGST(){
  
    this.AirManagementService.getGstbyCarrier(this.airlineDesignatorCode)
    .subscribe({
      next : (res) => {
        if(res ){
          let data:any
          data=res
          this.GstData=data?.carrierGSTList
          this.GstData.forEach((item:any)=>item.isValid=true)
          console.log( this.GstData)
        } else {
         
        } 
  
      },error : (err) => {
  
      }
    }
  )
  }
  onlyNumberKey(event:any) {
     
    let charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31
        && (charCode < 48 || charCode > 57))
        return false;
    return true;
  }

  onlyNumberSpecialKey(event: any): boolean {
    let charCode = (event.which) ? event.which : event.keyCode;

    // Allow numbers (48-57), plus sign (+ which is 43), minus sign (- which is 45), and colon (: which is 58)
    if (
        (charCode >= 48 && charCode <= 57) ||  // Allow numbers
        charCode === 43 ||  // Allow plus sign (+)
        charCode === 45 ||  // Allow minus sign (-)
        charCode === 58     // Allow colon (:)
    ) {
        return true;
    }

    // Prevent default for other characters
    return false;
}
  disable=false

disableGst(){
  let regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
this.GstData.forEach((item:any)=>{
if(regex.test(item.gstNumber)){
  this.disable=true
}else{
  this.disable=false
}
  })

  return this.disable
}
validateGST(item: any) {
  let regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  item.isValid = regex.test(item.gstNumber);
}

fareType:any={
  "carrierCode": '',
  "status": "A",
  "fareType": '',
  "fareTypeDisplay": ''
}

Addfare(item:any) {
  
  let fareType:any={
    "carrierCode": this.airlineDesignatorCode,
    "status": "A",
    "fareType": item?.fareType,
    "fareTypeDisplay": item?.fareTypeDisplay
  }
  this.AirManagementService.saveFareCarrier(fareType)
    .subscribe({
      next : (res) => {
        if(res.status==200 || res.status==201) {
          this.fareType.fareType=''    
          this.fareType.fareTypeDisplay=''

          this.toastMsgService.setMsg({msg : "Fare Type Added Successfully!",msgTitle : "Success", msgType : "I"});
         this.getfarelist()

        } else {
         
        } 

      },error : (err) => {
        this.toastMsgService.setMsg({msg : "Failed to save Fare Type ",msgTitle:  "Warning", msgType : "W"});


      }
    }
  )
}
Updatefare(item:any) {
  
  let fareType:any={
    "carrierCode": item?.carrierCode,
    "status": "A",
    "fareType": item?.fareType,
    "fareTypeDisplay": item?.fareTypeDisplay,
    "uuid":item?.uuid
  }
  this.AirManagementService.saveFareCarrier(fareType)
    .subscribe({
      next : (res) => {
        if(res.status==200 || res.status==201) {
          this.toastMsgService.setMsg({msg : "Fare Type  Updated Successfully!",msgTitle : "Success", msgType : "I"});
         this.getfarelist()

        } else {
         
        } 

      },error : (err) => {
        this.toastMsgService.setMsg({msg : "Failed to Update Fare Type ",msgTitle:  "Warning", msgType : "W"});


      }
    }
  )
}

fareList:any=[]
getfarelist(){
  this.AirManagementService
  .getCarrierFareList(this.airlineDesignatorCode)
  .subscribe({
    next : (res:any) => {
      if(res) {
        const data = res
        this.fareList=data
        
      
      
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}

Disabled(){
  
  if(this.fareType.fareType&&this.fareType.fareTypeDisplay){
    return false
  }
  return true
}

DisabledUpDATE(item:any){
  
  if(item.fareType&&item.fareTypeDisplay){
    return false
  }
  return true
}

foreign:any={
  "carrierCode": '',
  "status": "A",
  "foreignTaxName": '',
  "foreignTaxMapping": ''
}
AddTax(item:any) {
  
  let fareType:any={
    "carrierCode": this.airlineDesignatorCode,
    "status": "A",
    "foreignTaxName": item?.foreignTaxName,
    "foreignTaxMapping": item?.foreignTaxMapping
  }
  this.AirManagementService.saveTaxCarrier(fareType)
    .subscribe({
      next : (res) => {
        if(res.status==200 || res.status==201) {
          this.foreign.foreignTaxName=''    
          this.foreign.foreignTaxMapping=''

          this.toastMsgService.setMsg({msg : "Foreign Tax Added Successfully!",msgTitle : "Success", msgType : "I"});
          this.getForeignlist()

        } else {
         
        } 

      },error : (err) => {
        this.toastMsgService.setMsg({msg : "Failed to Save Foreign Tax ",msgTitle:  "Warning", msgType : "W"});


      }
    }
  )
}
DisabledTax(){
  if(this.foreign.foreignTaxMapping&&this.foreign.foreignTaxName){
    return false
  }
  return true
}
DisabledTUpDATE(item:any){
  
  if(item.foreignTaxMapping&&item.foreignTaxName){
    return false
  }
  return true
}
UpdateTax(item:any) {
  
  let fareType:any={
    "carrierCode": this.airlineDesignatorCode,
    "status": "A",
    "foreignTaxName": item?.foreignTaxName,
    "foreignTaxMapping": item?.foreignTaxMapping,
    "uuid":item?.uuid

  }
  this.AirManagementService.saveTaxCarrier(fareType)
    .subscribe({
      next : (res) => {
        if(res.status==200 || res.status==201) {
          this.foreign.foreignTaxName=''    
          this.foreign.foreignTaxMapping=''

          this.toastMsgService.setMsg({msg : "Foreign Tax Updated Successfully!",msgTitle : "Success", msgType : "I"});
          this.getForeignlist()

        } else {
         
        } 

      },error : (err) => {
        this.toastMsgService.setMsg({msg : "Failed to Update Foreign Tax ",msgTitle:  "Warning", msgType : "W"});


      }
    }
  )
}

ForeignList:any=[]
getForeignlist(){
  this.AirManagementService
  .getCarrierForeignList(this.airlineDesignatorCode)
  .subscribe({
    next : (res:any) => {
      if(res) {
        const data = res
        this.ForeignList=data
        
      
      
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}
}
